import { useGetBooking } from '#/hooks/useGetBooking';
import { useGetBranchByCode } from '#/hooks/useGetBranchByCode';
import { useRootStore } from '#/hooks/useRootStore';
import { JucyCountryCode } from '@jucy/rentals-common';

export const useContactUsLink = (reservationRef?: string) => {
    const { data: booking } = useGetBooking(reservationRef);
    const { data: pickUpBranch } = useGetBranchByCode(booking?.pickUpLocation);
    const store = useRootStore();
    const region = pickUpBranch?.countryCode?.toLowerCase() as JucyCountryCode;

    return store.getBrandContactUsLink(region || JucyCountryCode.nz);
};
